import Vue from 'vue'
import vuetify from './plugins/vuetify';
import VueFilterDateFormat from 'vue-filter-date-format';
import DateFilter from './filters/date'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import rutjs from 'rut.js'
import ProfessionalAvatar from './components/ProfessionalAvatar.vue'
import './registerServiceWorker'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import 'vue2-animate/dist/vue2-animate.min.css'
import SweetAlertIcons from 'vue-sweetalert-icons';
import VueGtag from "vue-gtag";

// Set API URL (por entorno: .env.production / .env.development; fallback local)
axios.defaults.baseURL = process.env.VUE_APP_API_URL || 'http://gestion.co.lan/api-clientes/1';
// Interceptor de salida
axios.interceptors.request.use(function (config) {
    let token = store.getters.getToken;
    if (token) {
        config.params = { ...config.params, token: token };
    }
    // FEAT-2026-07-08-001: token efímero de reserva (el backend fuerza el
    // filtrado por previsión a partir de él)
    let bookingToken = store.getters.getBookingToken;
    if (bookingToken) {
        config.headers = { ...config.headers, 'x-booking-token': bookingToken };
    }
    return config;
});
// Interceptor de entrada
axios.interceptors.response.use(undefined, function (err) {
    if (err.response && err.response.status === 403) {
        // Token de reserva expirado/ inválido: limpiar y volver a identificación
        if (store.getters.hasBookingSession && !store.getters.isLoggedIn) {
            store.dispatch("clearBookingSession").then(() => {
                if (router.currentRoute.path !== "/") {
                    router.push({ path: "/", query: { expired: "1" } });
                }
            });
        } else {
            store.dispatch("logout").then(() => {
                store.dispatch("clearBookingSession");
                router.push("/");
            });
        }
    }
    return Promise.reject(err);
});

Vue.prototype.$http = axios;
Vue.prototype.$rutjs = rutjs;

Vue.config.productionTip = false
Vue.use(SweetAlertIcons)
Vue.use(VueAxios, axios)
Vue.use(VueFilterDateFormat)
Vue.use(VueGtag, {
    config: { id: "UA-157981568-2" }
}, router);
Vue.component('professional-avatar', ProfessionalAvatar)
new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')

Vue.filter('date', DateFilter);
